

    require('./marker/MarkAreaModel');
    require('./marker/MarkAreaView');

    require('../echarts').registerPreprocessor(function (opt) {
        // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/markArea.js
// module id = 455
// module chunks = 1